var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.97873C10.2375 2.97873 11.25 4.01933 11.25 5.29119C11.25 6.56305 10.2375 7.60366 9 7.60366C7.7625 7.60366 6.75 6.56305 6.75 5.29119C6.75 4.01933 7.7625 2.97873 9 2.97873ZM9 14.5411C12.0375 14.5411 15.525 16.0326 15.75 16.8535H2.25C2.50875 16.021 5.97375 14.5411 9 14.5411ZM9 0.66626C6.51375 0.66626 4.5 2.73592 4.5 5.29119C4.5 7.84647 6.51375 9.91612 9 9.91612C11.4862 9.91612 13.5 7.84647 13.5 5.29119C13.5 2.73592 11.4862 0.66626 9 0.66626ZM9 12.2286C5.99625 12.2286 0 13.7779 0 16.8535V19.166H18V16.8535C18 13.7779 12.0037 12.2286 9 12.2286Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUserIcon);
export default __webpack_public_path__ + "static/media/header-user-icon.5c57e541.svg";
export { ForwardRef as ReactComponent };